package com.cybersoftsolution.cybersoftsolutionweb.models

import com.cybersoftsolution.cybersoftsolutionweb.models.Values.CONFIG_ID_DEFAULT_VALUE
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
actual data class Config(
    @SerialName("_id")
    actual var id: String? =  CONFIG_ID_DEFAULT_VALUE,
    actual var isProductionMode: Boolean? = null,
    actual var emailSender: String? = null,
    actual var otpExpirationTimeInMin: Long? = null
)



